import { FileExtension } from '../../../common/models/enums/fileExtension';
import { getFormattedDate } from '../../../common/utils';

export const getReturnCodeDefaultName = (restaurantName: string) =>
  `${restaurantName}_${getFormattedDate(new Date().toISOString())}`;

export const getReturnCodeFileName = (returnCodeName: string) => `${returnCodeName}-return code.${FileExtension.PNG}`;

export const getReturnCodePosterFileName = (returnCodeName: string) => `${returnCodeName}-poster.${FileExtension.PDF}`;
